var app = angular.module("leonardo");

var ApprovalListFilters = function(
  $scope,
  $controller,
  CategoryCacheRestService,
  ReportService,
  TaskService,
  WorkFlowService
) {

$controller('FiltersBaseController', { $scope: $scope });

$scope.categories = [];

CategoryCacheRestService.getCategories().then(function(response) {

  if (response && response.length > 0) {
    $scope.categories = response.map(function(category) {
      return { id: category.id, name: category.name }; 
    });
  } else {
    console.warn('No categories found or invalid response');
    $scope.categories = []; 
  }
}, function(error) {
  console.error('Failed to fetch categories:', error);
  $scope.categories = []; 
});

$scope.$watch('categories', function(newValue) {
  if (newValue.length > 0) {
    const categoryFilter = $scope.filters_options.find(option => option.id === 'category');
    if (categoryFilter) {
      categoryFilter.options = newValue;
    }
  }
});

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
      ]
    },
    {
      group: 'date',
      name: 'By Date',
      elements: [
        {
          id: 'original_submission_from',
          name: 'Original Submission From',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Original Submission From',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          endDate: 'original_submission_to'
        },
        {
          id: 'original_submission_to',
          name: 'Original Submission To',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Original Submission To',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          startDate: 'original_submission_from'
        },
        {
          id: 'latest_submission_from',
          name: 'Latest Submission From',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Latest Submission From',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          endDate: 'latest_submission_to'
        },
        {
          id: 'latest_submission_to',
          name: 'Latest Submission To',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Latest Submission To',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          startDate: 'latest_submission_from'
        },
        {
          id: 'due_date_from',
          name: 'Due Date From',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Due Date From',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          endDate: 'due_date_to'
        },
        {
          id: 'due_date_to',
          name: 'Due Date To',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Due Date To',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          startDate: 'due_date_from'
        },
        {
          id: 'not_past_due',
          name: 'Past Due',
          label: null,
          inline: false,
          type: 'options',
          multiple: false,
          placeholder: 'All Tasks',
          condition: true,
          options: [{id: 1, label: 'Is Past Due'}, {id: 0, label: 'Is Not Past Due'}],
          conflicts: []
        },
      ]
    },
    {
      id: 'category',
      name: 'Category',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Categories',
      condition: true,
      options:$scope.categories,
      conflicts: ['sector']
    },
    {
      id: 'priority',
      name: 'Priority',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Priorities',
      condition: true,
      options: ReportService.PRIORITY_OPTIONS,
      conflicts: []
    },
    {
      id: 'approval_steps',
      name: 'Approval Step',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Steps',
      condition: true,
      options: TaskService.getApprovalSteps(),
      conflicts: []
    },
    {
      id: 'revision_number',
      name: 'Revision',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Revisions',
      condition: true,
      options: TaskService.getRevisions(),
      conflicts: []
    },
    {
      id: 'submitted_by',
      name: 'Original Submitter',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      modeUser: true,
      placeholder: 'All Submitters',
      condition: true,
      options: TaskService.getSubmitters({order_by: 'first_name'}),
      conflicts: []
    },
    {
      id: 'workflow',
      name: 'Workflow',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'All Workflows',
      condition: true,
      service: WorkFlowService,
      serviceFunction: WorkFlowService.approvalWorkflowList,
      conflicts: []
    },
    {
      id: 'approver_ids',
      name: 'Current Approver',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      modeUser: true,
      placeholder: 'All Approvers',
      condition: true,
      options: TaskService.getCurrentApprovers({order_by: 'first_name'}),
      conflicts: []
    },
    // {
    //   id: 'current_approver',
    //   name: 'Current Approver',
    //   label: 'current_approver',
    //   inline: false,
    //   type: 'checkbox',
    //   condition: true,
    //   conflicts: []
    // },
    {
      id: 'keywords',
      name: 'Keyword Search',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Keyword Search',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter 
    }
  ];

  $scope.$on('filter-service:filter-changed', function (event, key, value) {
    if (key === 'managed_by_reports') {
      TaskService.getCurrentApprovers({managed_by: !isEmpty(value) ? value : undefined, order_by: 'first_name'}).then(function (data) {
        let currentApproverFilter = $scope.filters_options.find((c) => c.id === 'approver_ids');
        currentApproverFilter.options = data.results || data;
      });
    }
  });

  $scope.$on('filter-service:filter-removed', function (event, key) {
    if (key === 'managed_by_reports') {
      TaskService.getCurrentApprovers({order_by: 'first_name'}).then(function (data) {
        let currentApproverFilter = $scope.filters_options.find((c) => c.id === 'approver_ids');
        currentApproverFilter.options = data.results || data;
      });
    }
  });
  $scope.filterService.showFilters(['property_reports', 'keywords','workflow','approval_steps','approver_ids']);

};

app.controller('ApprovalListFilters', [
  '$scope',
  '$controller',
  'CategoryCacheRestService',
  'ReportService',
  'TaskService',
  'WorkFlowService',
  ApprovalListFilters
]);
 